import { ALERT_TYPES } from '../actionTypes';

export const alertActions = {
    success,
    error,
    info,
    clear
};

function success(message) {
    return { type: ALERT_TYPES.SUCCESS, message };
}

function error(message) {
    return { type: ALERT_TYPES.ERROR, message };
}

function info(message) {
    return { type: ALERT_TYPES.INFO, message };
}

function clear() {
    return { type: ALERT_TYPES.CLEAR };
}
